export default __webpack_public_path__ + "static/media/967.e0c8e850.png";